export class EnterpriseWorkflows {
  public static wfs = [
    {
      // Terminbuchung - Calendly workflow
      appliesto: '',
      attachment: '',
      attachmentURL: '',
      calendlyLink: '',
      document: '',
      documentName: '',
      documentURL: '',
      dothis: 'calendly',
      dynamicAttachment: '',
      emailText: '',
      id: '',
      information: [],
      lastChosenWorkflow: '',
      lastChosenWorkflowMatching: { name: 'Terminbuchung' },
      name: 'Terminbuchung',
      priorityOfWorkflow: 'below',
      prompt: '',
      receiver: 'applicant',
      smsCountryCode: '',
      smsText: '',
      status: 'aktiv',
      subWorkflows: [],
      when: 'now',
      whenthishappens: 'calendly',
      workflowSendEmailMessage: '',
      workflowSendEmailSubject: 'Terminbuchung für Bewerbungsgespräch',
      workflowSendEmailTitle: '',
      smsPhoneNumbers: [],
      callPhoneNumbers: [],
      whatsAppPhoneNumbers: [],
      customTime: {},
      reminder: {
        betreffText: 'Buche dir jetzt deinen Gesprächstermin',
        emailText:
          'Hallo $firstname, vielen Dank für deine Bewerbung bei $companyname. Bitte buche dir einen passenden Termin für unser Kennenlerngespräch: $calendlyURL',
        smsText:
          'Hallo $firstname, vielen Dank für deine Bewerbung bei $companyname. Bitte buche dir einen Termin: $calendlyURL',
        smsCountryCode: '',
      },
      agent: {},
    },
    {
      // Profil lang (untergeordnet) - main workflow created first
      appliesto: '',
      attachment: '',
      attachmentURL: '',
      calendlyLink: '',
      document: '',
      documentName: 'Ausführliches Bewerberprofil',
      documentURL: '', // Will be set by Firebase upload
      dothis: 'email',
      dynamicAttachment: 'applicantProfile',
      emailText: '',
      id: '',
      information: ['dynamicAttachments'],
      lastChosenWorkflow: '',
      lastChosenWorkflowMatching: { name: 'Profil lang' },
      name: 'Profil lang',
      priorityOfWorkflow: 'below', // untergeordnet
      prompt: '',
      receiver: 'customer',
      smsCountryCode: '',
      smsText: '',
      status: 'aktiv',
      subWorkflows: [],
      when: 'now',
      whenthishappens: 'flowchartknot',
      workflowSendEmailMessage:
        'Sehr geehrte Damen und Herren,\n\nanbei erhalten Sie das ausführliche Profil des Bewerbers nach Abschluss des Interviews. Das Profil enthält alle relevanten Informationen für Ihre Entscheidung.\n\nBei Fragen stehen wir Ihnen gerne zur Verfügung.',
      workflowSendEmailSubject: 'Ausführliches Bewerberprofil - $applicantName',
      workflowSendEmailTitle: '',
      smsPhoneNumbers: [],
      callPhoneNumbers: [],
      whatsAppPhoneNumbers: [],
      customTime: {},
      reminder: {},
      agent: {},
    },
    {
      // Teaserprofil und Matching (übergeordnet) - subworkflow of Profil Lang
      appliesto: '',
      attachment: '',
      attachmentURL: '',
      calendlyLink: '',
      document: '',
      documentName: 'Teaser-Profil und Matching-Analyse',
      documentURL: '', // Will be set by Firebase upload
      dothis: 'email',
      dynamicAttachment: 'applicantProfileForDisponentAndMatching',
      emailText: '',
      id: '',
      information: ['dynamicAttachments'],
      lastChosenWorkflow: 'Profil lang',
      lastChosenWorkflowMatching: { name: 'Teaserprofil und Matching' },
      name: 'Teaserprofil und Matching',
      priorityOfWorkflow: 'superior', // übergeordnet
      prompt: '',
      receiver: 'customer',
      smsCountryCode: '',
      smsText: '',
      status: 'aktiv',
      subWorkflows: [],
      when: 'now',
      whenthishappens: 'flowchartknot',
      workflowSendEmailMessage:
        '<!DOCTYPE html>\n<html lang="de">\n<head>\n    <meta charset="UTF-8">\n    <title>Passender Kandidat gefunden</title>\n</head>\n<body style="font-family: Arial, sans-serif; font-size: 14px; color: #000; line-height: 1.6;">\n    <p>Sehr geehrte Damen und Herren,</p>\n    \n    <p>wir freuen uns, Ihnen einen vielversprechenden Kandidaten für Ihre Position <strong>$jobTitle</strong> vorstellen zu können.</p>\n    \n    <p>Basierend auf Ihren Anforderungen haben wir eine umfassende Matching-Analyse durchgeführt:</p>\n    \n    <h3>Ihre Anforderungen:</h3>\n    <ul>\n        <li>$requirement1</li>\n        <li>$requirement2</li>\n        <li>$requirement3</li>\n    </ul>\n    \n    <h3>Kandidaten-Match:</h3>\n    <ul>\n        <li>✓ $match1</li>\n        <li>✓ $match2</li>\n        <li>✓ $match3</li>\n    </ul>\n    \n    <p>Das beigefügte Teaser-Profil gibt Ihnen einen ersten Überblick über die Qualifikationen und Erfahrungen des Kandidaten. Bei Interesse können wir Ihnen gerne das vollständige Profil zur Verfügung stellen.</p>\n    \n    <p>Für Rückfragen und die Terminvereinbarung stehen wir Ihnen jederzeit zur Verfügung.</p>\n    \n    <p>Mit freundlichen Grüßen<br>\nIhr Recruiting-Team</p>\n</body>\n</html>',
      workflowSendEmailSubject: 'Passender Kandidat für $jobTitle - Teaser-Profil',
      workflowSendEmailTitle: '',
      smsPhoneNumbers: [],
      callPhoneNumbers: [],
      whatsAppPhoneNumbers: [],
      customTime: {},
      reminder: {},
      agent: {},
    },
  ];
}
